<template>
  <div class="text-page">
    <vue-headful :title="doctitle" />
    <div
      class="position-relative"
      style="max-width: 1900px; margin-left: auto; margin-right: auto"
    >
      <b-container>
        <b-row>
          <b-col>
            <h1>Program Committee</h1>
            <p>
              Øredev is an international developers conference, made up of 100+
              top-notch speakers from all over the world sharing their 
              knowledge, 6 keynote speaches revolving around a theme that changes
              each year, and 1200+ attendees during 3 days at the beginning of
              November.
            </p>
            <p class="m-0">
              All of this is coordinated by 2 people and the program is curated
              by our Program Committee. We are immensely thankful to them for
              making Øredev what it is.
            </p>
            <DividerPink />
            <h2>Members</h2>
            <p>
              These are the masterminds who have crafted this year's Øredev
              program. They are also some of the most driven, competent, and fun
              people we know and have spent hours inviting and selecting the
              right speakers to share their expertise as well as the latest tech
              trends on stage!
            </p>
            <p class="m-0">
              Without their invaluable contributions, there would be no program,
              no speakers, and no Øredev, and we are immensely grateful for
              their unwavering commitment to excellence!
            </p>
            <DividerBlue />
          </b-col>
        </b-row>
      </b-container>
      <b-container style="max-width: 925px">
        <div class="committee">
          <div
            class="member"
            v-for="member in committee"
            v-bind:key="member.name"
          >
            <img
              class="rounded-circle"
              :src="member.image"
              :alt="`committee member ${member.name}`"
            />
            <p style="margin-bottom: 5px">
              <b>{{ member.name }}</b>
            </p>
            <p class="m-0">{{ member.track }}</p>
          </div>
        </div>
      </b-container>
      <b-container>
        <b-row class="divider-margin">
          <b-col>
            <h2>Join the 2026 Øredev Program Committee</h2>
            <p>
              Do you want to shape one of the largest tech conferences in
              Scandinavia?<br />
              We are always on the lookout for new committee members!<br />
              You would be responsible for building a strong, coherent, balanced
              track together with another member of the committee. We feel it is
              extremely important to have someone to bounce ideas off, to a get
              second opinions, and to inspire one another.
            </p>
            <h2>Perks and Fun</h2>
            <p>
              Inviting speakers and shaping Øredev should feel like one of the
              perks.
            </p>
            <p>
              Naturally, you get a free ticket to the entire conference. You're
              also an integral part of the extracurriculars with the speakers.
            </p>
            <p class="m-0">
              If this sounds tempting, we would love to hear from you! 
              <a href="mailto:info@oredev.org">Get in touch</a>
            </p>
          </b-col>
        </b-row>
        <DividerOrange />
      </b-container>
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/shooting_star_yellow.png"
        class="position-absolute d-none d-xl-block"
        style="top: 5%; left: 4%; max-width: 11%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/pink_planet.png"
        fluid
        class="position-absolute d-none d-xl-block"
        style="top: 26%; right: 0%; max-width: 11%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/Shape_blue.png"
        class="position-absolute d-none d-xl-block"
        style="bottom: 59%; left: 6%; max-width: 8%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/planet.png"
        class="position-absolute d-none d-xl-block"
        style="bottom: 29%; right: 2%; max-width: 14%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/eye.png"
        class="position-absolute d-none d-xl-block"
        style="bottom: 8%; left: 3%; max-width: 10%"
        alt=""
        aria-hidden="true"
      />
    </div>
    <!-- Mobile Bottom Images -->
    <b-container
      fluid
      class="position-relative d-sm-none"
      style="height: 200vw; overflow: hidden"
    >
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_7.png"
        class="position-absolute"
        style="width: 88vw; left: -6vw; bottom: 111vw"
        alt="The Program Committee posing on stage together at Øredev 2024."
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_8.png"
        class="position-absolute"
        style="width: 90vw; right: -9vw; bottom: 13vw"
        alt="Members of the program committee laughing at a dinner table."
      />
    </b-container>
    <!-- Desktop Bottom Images -->
    <b-container
      fluid
      class="position-relative d-none d-sm-block"
      style="height: 25vw"
    >
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742856566/2025/Margin-images/shape_orange.png"
        class="position-absolute"
        style="width: 8vw; right: 14vw; bottom: 18vw"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_6.png"
        class="position-absolute"
        style="width: 23vw; left: 5vw; bottom: -5vw"
        alt="Speakers Kent Beck and Beth Andres-Beck on stage."
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156661/2025/Footer_pages/img_7.png"
        class="position-absolute"
        style="width: 23vw; left: 36vw; bottom: -9vw"
        alt="The Program Committee posing on stage together at Øredev 2024."
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_8.png"
        class="position-absolute"
        style="width: 23vw; left: 64vw; bottom: -5vw"
        alt="Members of the program committee laughing at a dinner table."
      />
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Committee",
  data() {
    return {
      doctitle: "Program Committee - " + this.$store.state.conferencename,
      committee: [
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171822/2025/Footer_pages/Committee/Anca_Lordanescu.png",
          name: "Anca Lordanescu",
          track: "AI",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171822/2025/Footer_pages/Committee/Balazs_Suhajda.png",
          name: "Balázs Suhajda",
          track: "OFF Track",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171823/2025/Footer_pages/Committee/Boris_Duran.png",
          name: "Boris Duran",
          track: "Data",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171823/2025/Footer_pages/Committee/Ema_Krcic.png",
          name: "Ema Krcic",
          track: "AI",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171824/2025/Footer_pages/Committee/Hanna_Gustavsson.png",
          name: "Hanna Gustavsson",
          track: "Eagle Eye",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171824/2025/Footer_pages/Committee/Henrik_Reich.png",
          name: "Henrik Reich",
          track: "Data",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171825/2025/Footer_pages/Committee/Jakob_Nilsson-Ehle.png",
          name: "Jakob Nilsson Ehle",
          track: "Web",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171826/2025/Footer_pages/Committee/Jens_Bogarve.png",
          name: "Jens Bogarve",
          track: "Security",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171828/2025/Footer_pages/Committee/Jonas_Flodqvist.png",
          name: "Jonas Flodqvist",
          track: "Cloud & DevOps",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171827/2025/Footer_pages/Committee/Johannes_Klose_Andersen.png",
          name: "Johannes Klose Andersen",
          track: "Leadership & MGMT",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171829/2025/Footer_pages/Committee/Kenneth.png",
          name: "Kenneth Geisshirt",
          track: "Architecture",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171844/2025/Footer_pages/Committee/Mats_Alritzson.png",
          name: "Mats Alritzson",
          track: "Cloud & DevOps",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171845/2025/Footer_pages/Committee/Mattias_Karlsson.png",
          name: "Mattias Karlsson",
          track: ".Net",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171841/2025/Footer_pages/Committee/Maria_Kedemo.png",
          name: "Maria Kedemo",
          track: "Quality & Test",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171843/2025/Footer_pages/Committee/Maryam_Sarrafkia.png",
          name: "Maryam Sarrafkia",
          track: ".NET",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171842/2025/Footer_pages/Committee/Martin_Rosen_lidholm.png",
          name: "Martin Rosén-Lidholm",
          track: "Leadership & MGMT",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171840/2025/Footer_pages/Committee/Maisa_Dabus.png",
          name: "Maisa Dabus",
          track: "Øredev theme & Keynotes ",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171846/2025/Footer_pages/Committee/Nicola_Lindgren.png",
          name: "Nicola Lindgren",
          track: "Quality & Test",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171847/2025/Footer_pages/Committee/Patrik_Svensson.png",
          name: "Patrik Svensson",
          track: "OFF Track",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171848/2025/Footer_pages/Committee/Sanne_Femling.png",
          name: "Sanne Femling",
          track: "Security",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171849/2025/Footer_pages/Committee/Sara_Ahrari.png",
          name: "Sara Ahrari",
          track: "JVM",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171850/2025/Footer_pages/Committee/Thomas_Lundstro%CC%88m.png",
          name: "Thomas Lundström",
          track: "JVM",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171852/2025/Footer_pages/Committee/Tshepiso_Lehutjo.png",
          name: "Tshepiso Lehutjo",
          track: "Web",
        },
        {
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1743171854/2025/Footer_pages/Committee/Zul_Mehdi.png",
          name: "Zul Mehdi",
          track: "Architecture",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.committee {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  grid-column-gap: 0%;
  justify-content: center;
  text-align: center;
  img {
    max-width: 200px;
    margin-bottom: 26px;
  }
  margin-bottom: -72px;
  .member {
    margin-bottom: 72px;
  }
  @media (max-width: 991px) {
    grid-template-columns: 33% 33% 33%;
  }
  @media (max-width: 767px) {
    img {
      max-width: 150px;
      margin-bottom: 8px;
    }
    margin-bottom: -24px;
    .member {
      margin-bottom: 24px;
    }
  }
  @media (max-width: 576px) {
    grid-template-columns: 50% 50%;
  }
  @media (max-width: 350px) {
    grid-template-columns: 100%;
  }
}
</style>






// WEBPACK FOOTER //
// src/views/Committee.vue